<template>
	<div class="card border-0 card-with-shadow">
		<div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">

			<h5 v-show="isDetailsActive" class="card-title text-muted mb-0">{{ $t('more_details') }}</h5>
			<h5 v-show="!isDetailsActive" class="card-title text-muted mb-0">{{ $t('more_edit_details') }}</h5>

			<div>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoClose">
					<app-icon name="x-square" stroke-width="1"/>
				</a>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoSync">
					<app-icon name="check-square" stroke-width="1"/>
				</a>
				<a v-show="isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoEdit">
					<app-icon name="edit" stroke-width="1"/>
				</a>
			</div>

		</div>
		<div class="card-body">

			<div v-show="isDetailsActive">

				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('country_buy') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.country_buy">
								<span v-for="item in countryList" v-if="item.id == detailsData.country_buy">
      								<a :href="'/crm/persons/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
							</template>
							<template v-else>
								-
							</template>
						
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('date_buy') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.date_buy">
								{{ formatDateToLocal(detailsData.date_buy) }}
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
			
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('country_made') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.country_made">
								<span v-for="item in countryList" v-if="item.id == detailsData.country_made">
      								<a :href="'/crm/persons/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('size') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.size">
								{{ detailsData.size }}
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('material') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.material">
								{{ detailsData.material }}
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('designer') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.designer">
								{{ detailsData.designer }}
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
			
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('rest') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.rest">
								<span v-for="item in peopleList" v-if="item.id == detailsData.rest">
      								<a :href="'/crm/persons/' + item.id + '/edit'" target="_blank">{{ item.name }}</a>
    							</span>
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
			
			
			
				
				
							
			</div>

			<div v-show="!isDetailsActive">
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('country_buy') }}</label>
						<div class="col-7">
						<app-input
							type="search-select"
							list-value-field="name"
							:list="countryList"
							:placeholder="$t('choose_a_country')"
							v-model="detailsData.country_buy"
						/>
						
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('date_buy') }}</label>
						<div class="col-7">
							<app-input
                				v-model="detailsData.date_buy"
                				:placeholder="$t('choose_a_date')"
								:popover-position="'top-start'"
								type="date"
              				/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('country_made') }}</label>
						<div class="col-7">
						<app-input
							type="search-select"
							list-value-field="name"
							:list="countryList"
							:placeholder="$t('choose_a_country')"
							v-model="detailsData.country_made"
						/>

						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('size') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.size"
							           :error-message="$errorMessage(errors, 'size')"
										   :placeholder="$t('enter_size')"
							           type="text"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('material') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.material"
							           :error-message="$errorMessage(errors, 'material')"
										   :placeholder="$t('enter_material')"
							           type="text"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('designer') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.designer"
							           :error-message="$errorMessage(errors, 'designer')"
										    :placeholder="$t('enter_designer')"
							           type="text"/>
						</div>
					</div>
				</div>

				
			
		
				<div class="form-group mb-3">
					<div class="form-row">
					<label class="col-5 mb-0 d-flex align-items-center">{{ $t('rest') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.rest"
							           :error-message="$errorMessage(errors, 'rest')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>
							</div>
					</div>
				</div>
				
										 


			</div>

		</div>
	</div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, urlGenerator} from "@app/Helpers/helpers";

export default {
	name: "DetailsInformationFund",
	mixins: [FormMixin],
	props: {
		detailsData: {
			type: Object,
			required: true
		},
		detailsSyncUrl: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			urlGenerator,
			formatDateToLocal,
			isDetailsActive: true,
			formData: {},
			
			countryList: [],
			OwList: [
	  		 	{ id: "1", name: "Собственник",},
				{ id: "2", name: "Аренда",},

	  		],
			errors: {}
		}
	},
	computed: {
		contfundTypeList() {
			return this.$store.getters.contfundType
		},
	
		
		
		
		
		
	
		
		
		peopleList() {
			return this.$store.getters.getPerson
		},
		organizationList() {
			return this.$store.getters.getOrganization
		},
	},
	methods: {
		detailsInfoSync() {
this.formData.name = this.detailsData.name;
			
			this.formData.country_made = this.detailsData.country_made;
			this.formData.country_buy = this.detailsData.country_buy;
			
			this.formData.date_buy = this.detailsData.date_buy ? moment(this.detailsData.date_buy).format(
        "YYYY-MM-DD"
      ) : null;

			this.formData.size = this.detailsData.size;
			this.formData.material = this.detailsData.material;
			this.formData.designer = this.detailsData.designer;
			this.formData.rest = this.detailsData.rest;

			
			this.formData.fund_type_id = this.detailsData.fund_type_id;
			this.formData.owner_id = this.detailsData.owner_id;
			this.submitFromFixin('patch', this.detailsSyncUrl, this.formData);
		},

		afterError(response) {
			this.errors = response.data.errors
		},

		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.isDetailsActive = true
			this.errors = {}
			this.$emit('update-request');
		},

		detailsInfoClose() {
			this.isDetailsActive = true;
		},
		detailsInfoEdit() {
			this.isDetailsActive = false
		},
		getAllCountrys() {
			this.axiosGet(`crm/country`).then(({data}) => {
				this.countryList = data;
			});
		}
		
	},
	created() {
		
		
		
		
		this.$store.dispatch('getPerson');
		this.getAllCountrys();
	},
}
</script>

